module.exports = __webpack_public_path__ + "src/img/checker-round-on.5e131c2d.svg";